import React from "react";

const Java_Boolean = () => {
  return (
    <div>
      <h1>Java Boolean</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Boolean in Java.</p>
    </div>
  );
};

export default Java_Boolean;
